import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerUserService } from '../../services/wealthlane-customer-services';
import type { Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUsers } from '../../services/wealthlane-customer-services';

const useGetCustomerUserForSandbox = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
    | Array<{
        label: string;
        value: string;
    }>
    | undefined,
    unknown
> => {
    const customerUserForSandbox = useQuery(
        ['getCustomerUserForSandbox'],
        async () => {
            return await handleRequest(
                CustomerUserService.getApiCustomerApiAppCustomerUserCustomerUserForSandbox()
            );
        },
        {
            select: (data) => {
                return data?.map((user) => ({
                    label: user?.fullName ?? '',
                    value: user?.abpUserId ?? '',
                }));
            },
        }
    );

    return customerUserForSandbox;
};

export default useGetCustomerUserForSandbox;

